import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  quickMessagesContainer: {
    position: 'fixed',
    bottom: '70px',
    left: '-547px',
    right: '0',
    zIndex: 9999,
    maxHeight: '350px',
    overflow: 'hidden',
    borderRadius: '12px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    border: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`,
    maxWidth: '250px',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      left: '-140px'
    }
  },
  searchContainer: {
    padding: '12px 16px',
    borderBottom: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main
  },
  messagesList: {
    maxHeight: '280px',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 0,
    ...theme.scrollbarStylesSoft
  },
  messageItem: {
    display: 'flex',
    padding: '6px 8px',
    cursor: 'pointer',
    borderBottom: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
    }`,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    '&:hover': {
      backgroundColor: 'transparent !important'
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  messageIcon: {
    minWidth: '36px',
    color: theme.palette.blue_300.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  messageText: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .MuiListItemText-primary': {
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'uppercase',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& .MuiListItemText-secondary': {
      fontSize: '13px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      lineHeight: '1.4',
      maxWidth: '250px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  emptyState: {
    padding: '32px 16px',
    textAlign: 'center',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  actionsIconButton: {
    padding: theme.spacing(1),
    color: '#666',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '& .MuiSvgIcon-root, & svg:hover': {
      color: theme.palette.green_200.main
    }
  },
  buttonActionQuickMessage: {
    fontSize: '20px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main
  },
  messageTextPrimary: {
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  messageTextSecondary: {
    fontSize: '13px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    lineHeight: '1.4',
    maxWidth: '250px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  customTooltip: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    fontSize: '0.9rem',
    padding: '4px 16px'
  },
  customArrow: {
    color: theme.palette.blue_300.main
  }
}))
